/* ============================================================
   CANO — product variant selection (PDP + featured)
   ============================================================ */
(function () {
  "use strict";

  var C = window.CANO || {};

  function money(cents) {
    var fmt = (C.cart && C.cart.moneyFormat) || "${{amount}}";
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      var n = (cents / 100);
      if (key.indexOf("no_decimals") > -1) return Math.round(n).toLocaleString();
      return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  document.querySelectorAll("[data-product-root]").forEach(function (root) {
    var form = root.querySelector("[data-product-form]");
    var jsonEl = root.querySelector("[data-product-json]");
    if (!form || !jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!product || !product.variants || !product.variants.length) return; // handle-string JSON: cano.js takes over

    var idInput = form.querySelector("[data-variant-id]");
    var addBtn = form.querySelector("[data-add-btn]");
    var addLabel = form.querySelector("[data-add-label]");
    var selected = {}; // position -> value

    // seed from current
    var cur = product.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || product.variants[0];
    if (cur) product.options.forEach(function (o, i) { selected[i + 1] = cur.options[i]; });

    function findVariant() {
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i + 1]; });
      });
    }

    function optionAvailable(position, value) {
      // is there ANY available variant with this value at this position, matching other current selections
      return product.variants.some(function (v) {
        if (v.options[position - 1] !== value) return false;
        return v.available;
      });
    }

    function priceTargets() {
      return document.querySelectorAll('[data-price-for="' + product.id + '"], #ProductInfo-' + product.id + ' [data-price-main]');
    }

    function update(isInit) {
      var v = findVariant();
      // update unavailable styling
      form.querySelectorAll("[data-option-value]").forEach(function (b) {
        var pos = parseInt(b.getAttribute("data-position"), 10);
        var val = b.getAttribute("data-value");
        b.classList.toggle("is-unavailable", !optionAvailable(pos, val));
      });
      // update selected labels
      Object.keys(selected).forEach(function (pos) {
        var lbl = form.querySelector('[data-option-selected="' + pos + '"]');
        if (lbl) lbl.textContent = selected[pos];
      });

      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) addLabel.textContent = C.strings ? C.strings.soldOut : "Unavailable";
        return;
      }
      idInput.value = v.id;

      // main price (PDP)
      document.querySelectorAll('[data-price-main="' + product.id + '"]').forEach(function (el) {
        var html = money(v.price);
        if (v.compare_at_price > v.price) {
          html += ' <s>' + money(v.compare_at_price) + '</s>';
          el.classList.add("price--sale");
        } else { el.classList.remove("price--sale"); }
        el.innerHTML = html;
      });
      // inline price on button
      var inline = form.querySelector("[data-price-inline]");
      if (inline) inline.textContent = money(v.price);

      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) {
        if (v.available) {
          addLabel.innerHTML = (C.strings ? C.strings.addToCart : "Add to cart") + ' — <span data-price-inline>' + money(v.price) + '</span>';
        } else {
          addLabel.textContent = C.strings ? C.strings.soldOut : "Sold out";
        }
      }

      // swap main image to the variant's image (skip on initial load so a custom featured image stays)
      if (!isInit && v.featured_media) {
        var main = document.querySelector('[data-gallery-main="' + product.id + '"]');
        if (main && v.featured_media.preview_image) {
          var gimg = main.querySelector("img");
          if (gimg) { gimg.removeAttribute("srcset"); gimg.src = v.featured_media.preview_image.src.replace(/(\.[a-z]+)(\?.*)?$/i, "_1200x$1"); }
        }
      }

      // reflect in URL on PDP
      if (root.hasAttribute("data-update-url") && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u.toString());
      }
    }

    form.querySelectorAll("[data-option-value]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var pos = parseInt(btn.getAttribute("data-position"), 10);
        var val = btn.getAttribute("data-value");
        selected[pos] = val;
        form.querySelectorAll('[data-option-value][data-position="' + pos + '"]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle("is-active", on);
          b.setAttribute("aria-pressed", on ? "true" : "false");
        });
        update();
      });
    });

    // quantity steppers
    var qty = form.querySelector("[data-qty]");
    var minus = form.querySelector("[data-qty-minus]");
    var plus = form.querySelector("[data-qty-plus]");
    if (qty && minus && plus) {
      minus.addEventListener("click", function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener("click", function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
      qty.addEventListener("change", function () { var v = parseInt(qty.value, 10); qty.value = isNaN(v) || v < 1 ? 1 : v; });
    }

    // PDP thumbnails
    document.querySelectorAll('[data-thumb-for="' + product.id + '"]').forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var main = document.querySelector('[data-gallery-main="' + product.id + '"]');
        if (main) main.querySelector("img").src = thumb.getAttribute("data-full");
        document.querySelectorAll('[data-thumb-for="' + product.id + '"]').forEach(function (t) { t.setAttribute("aria-current", "false"); });
        thumb.setAttribute("aria-current", "true");
      });
    });

    update(true);
  });

  /* ---------- sticky add-to-cart bar (PDP) ---------- */
  (function () {
    var bar = document.querySelector("[data-sticky-atc]");
    var pdpRoot = document.querySelector("[data-update-url]");
    if (!bar || !pdpRoot) return;
    var form = pdpRoot.querySelector("[data-product-form]");
    var mainBtn = pdpRoot.querySelector("[data-add-btn]");
    var stickyBtn = bar.querySelector("[data-sticky-add]");

    if (stickyBtn && form) {
      stickyBtn.addEventListener("click", function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
      });
    }
    if (mainBtn && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var scrolledPast = e.boundingClientRect.top < 0;
          var show = !e.isIntersecting && scrolledPast;
          bar.classList.toggle("is-show", show);
          bar.setAttribute("aria-hidden", show ? "false" : "true");
        });
      }, { threshold: 0 });
      io.observe(mainBtn);
    }
  })();

  /* ---------- product recommendations (lazy) ---------- */
  document.querySelectorAll("[data-rec-url]").forEach(function (grid) {
    var url = grid.getAttribute("data-rec-url");
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var fresh = doc.querySelector(".product-grid");
      if (fresh && fresh.innerHTML.trim()) {
        grid.innerHTML = fresh.innerHTML;
        grid.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); });
      }
    }).catch(function () {});
  });
})();
